import { NavLink } from "react-router-dom";
import { getUserDisplayName } from "../utils/formatters.js";
import { LogoutIcon } from "./Icons.jsx";

function getUserInitials(user) {
  const displayName = user?.name || getUserDisplayName(user);
  return displayName
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("") || "CG";
}

export default function SidebarLayout({
  currentUser,
  sectionNav,
  onSignOut,
  children,
}) {
  return (
    <div className="cg-dashboard-shell">
      <aside className="cg-sidebar-column">
        <div className="cg-sidebar">
          <div className="cg-sidebar-brand">
            <span className="cg-kicker">Cologuard</span>
            <h1>Workspace</h1>
          </div>

          <nav className="cg-sidebar-nav" aria-label="Cologuard feature navigation">
            {sectionNav.map((section) => (
              <NavLink
                key={section.key}
                to={section.path}
                end={section.key === "summary"}
                className={({ isActive }) => `cg-sidebar-link ${isActive ? "active" : ""}`}
              >
                {section.label}
              </NavLink>
            ))}
          </nav>

          <div className="cg-sidebar-user">
            <div className="cg-user-avatar" aria-hidden="true">{getUserInitials(currentUser)}</div>
            <div className="cg-sidebar-user-details">
              <strong className="cg-account-name">{currentUser.name || getUserDisplayName(currentUser)}</strong>
              <span className="cg-account-email">{currentUser.email}</span>
              <span className="cg-account-role">{currentUser.role} access</span>
            </div>
            <button type="button" className="cg-signout-button" onClick={onSignOut}>
              <LogoutIcon />
              Sign out
            </button>
          </div>
        </div>
      </aside>

      <div className="cg-dashboard-main">{children}</div>
    </div>
  );
}
